<template>
  <span>
    Requested
    <humanize-time :time="request.createdAt" class="inline-block" />
    <span v-if="request.creator">
      by <user-label :user="request.creator" />
    </span>.
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import HumanizeTime from '@/components/HumanizeTime.vue';
import UserLabel from '@/iam/user/UserLabel.vue';
import { ReconnectRequest } from '@/social/types';

export default defineComponent({
  components: { UserLabel, HumanizeTime },
  props: {
    request: {
      type: Object as () => ReconnectRequest,
      required: true,
    },
  },
});
</script>
